<template>
  <div>
    <div class="promo-bar" v-show="addPromoAllowed">
      <v-row>
        <v-col cols="6" sm="4" md="3" lg="2"
          ><v-text-field
            dense
            filled
            hide-details
            v-model="promoCode"
            :placeholder="$t('checkout.enter_promo_code')"
          ></v-text-field
        ></v-col>
        <v-col class="d-flex align-center">
          <v-btn small rounded color="accent" class="accentText--text" @click="addPromo">{{ $t("placeorder") }}</v-btn>
        </v-col>
      </v-row>
    </div>

    <ul
      id="promo-list"
      :class="['promo-list', ua_isMobile() ? 'promo-list-mobile' : 'promo-list-desktop']"
      v-show="$store.getters.availablePromos.length > 0"
    >
      <li v-for="promo in $store.getters.availablePromos" :key="promo.PromoteCode">
        <v-card x-shaped elevation="1" class="promo-box" @click="promoClicked(promo)">
          <v-img :src="getPromoImageSrc(promo)"></v-img>

          <div
            v-if="promo.CustomData != null && promo.CustomData.ImageEffect != null && promo.CustomData.ImageEffect"
            class="half-circle-right"
          ></div>
          <div
            v-if="promo.CustomData != null && promo.CustomData.ImageEffect != null && promo.CustomData.ImageEffect"
            class="half-circle-left"
          ></div>

          <!--         <v-img
          :class="[
            {
              'image-blur':
                promo.CustomData == null || promo.CustomData.ImageBlur == null || promo.CustomData.ImageBlur,
            },
          ]"
          :src="promo.CustomData != null && promo.CustomData.ImageSrc != null ? promo.CustomData.ImageSrc : ''"
        ></v-img> -->

          <!-- <v-btn class="promo-add-to-cart" small outlined color="accent">{{ $t("placeorder") }}</v-btn> -->
          <div
            v-if="
              promo.CustomData == null || promo.CustomData.OrderButtonHide == null || !promo.CustomData.OrderButtonHide
            "
            class="promo-add-to-cart elevation-4"
          >
            {{ $t("placeorder") }}
          </div>

          <div class="promo-content">
            <div :class="['promo-title', getPromoTitleSizeClass(promo)]">
              <div v-if="$store.state.descrIndex == 1">
                {{ promo.title1 }}
              </div>
              <div v-else-if="$store.state.descrIndex == 2">
                {{ promo.title2 }}
              </div>
              <div v-else>
                {{ promo.title }}
              </div>
            </div>
            <div class="promo-detail">
              <div v-if="$store.state.descrIndex == 1">
                {{ promo.detail1 }}
              </div>
              <div v-else-if="$store.state.descrIndex == 2">
                {{ promo.detail2 }}
              </div>
              <div v-else>
                {{ promo.detail }}
              </div>
            </div>
          </div>
        </v-card>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      promoCode: "",
    };
  },

  computed: {
    addPromoAllowed() {
      if (this.$store.state.order.orderType != this.$store.state.OT_DINEIN && this.$store.state.promos.length > 0) {
        let promoOi = this.$store.state.order.orderItems.find(oi => oi.promo != null);
        return promoOi == null;
      } else return false;
    },
  },

  methods: {
    async promoClicked(promo) {
      let promoValidated = await this.validatePromo(promo);
      if (!promoValidated) return;

      this.addPromoToCart(promo);
    },

    getPromoImageSrc(promo) {
      let url = "https://api.mrsdigi.com/promoimg/promo.jpg";
      if (!this.isEmptyObject(promo.Image)) {
        if (promo.Image.AltUrl != "") url = promo.Image.AltUrl;
        else if (promo.Image.DownloadPath != "") url = promo.Image.DownloadPath;
      }

      return url;
    },

    getPromoTitleSizeClass(promo) {
      let pts_class = "promo-title-size-normal";
      if (promo != null && promo.CustomData != null && promo.CustomData.TitleSize != null) {
        if (promo.CustomData.TitleSize == "small") pts_class = "promo-title-size-small";
        else if (promo.CustomData.TitleSize == "large") pts_class = "promo-title-size-large";
        else if (promo.CustomData.TitleSize == "xlarge") pts_class = "promo-title-size-xlarge";
      }

      return pts_class;
    },

    async addPromo() {
      console.log(this.promoCode);

      let memberCode;
      if (this.$store.state.member != null) memberCode = this.$store.state.member.MemberCode;
      let getResp = await this.rest_getMemberPromo(memberCode, this.promoCode);
      let promo = null;
      if (getResp.result == "ok") {
        promo = getResp.record;

        this.addExInfoToPromo(promo);
      }

      if (promo != null) {
        let promoValidated = await this.validatePromo(promo);
        if (!promoValidated) return;

        this.addPromoToCart(promo);
        this.promoCode = "";
      } else {
        this.$root.messageDialog(
          this.$t("error_alert_title"),
          "",
          this.$t("error_promo_redeemed", { promo: this.promoCode })
        );

        this.promoCode = "";
        return;
      }
    },
  },
};
</script>

<style lang="scss">
$promo-width: 200px;
$promo-height: 300px;
$promo-image-height: 100px;
$half-circle-radius: 15px;

.half-circle {
  width: $half-circle-radius;
  height: calc(#{$half-circle-radius} * 2);
  background-color: white;
  border: 2px solid rgb(240, 240, 240);
  position: absolute;
  top: calc((#{$promo-image-height} / 2) - #{$half-circle-radius});
}

.half-circle-right {
  @extend .half-circle;
  border-top-left-radius: $half-circle-radius;
  border-bottom-left-radius: $half-circle-radius;

  border-right: 0;
  right: -2px;
}

.half-circle-left {
  @extend .half-circle;
  border-top-right-radius: $half-circle-radius;
  border-bottom-right-radius: $half-circle-radius;
  border-left: 0;
  left: -2px;
}

.promo-bar {
  .col {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.promo-list {
  .promo-box {
    height: $promo-height;
    width: $promo-width;
    //margin: 0px 8px;
    .v-image {
      //border-bottom-right-radius: 24px;
      //border-bottom-left-radius: 4px;
      //max-height: 150px;
      //max-width: 200px;
      height: 100px;
      width: $promo-width;
    }
    .image-blur {
      //filter: opacity(10%);
    }

    .promo-add-to-cart {
      position: absolute;
      //top: 4px;
      bottom: 4px;
      right: 4px;
      //left: 4px;
      //background-color: rgba(255, 255, 255, 0.9) !important;
      font-size: 0.8em;
      //font-weight: bold;
      background-color: var(--v-accent-base);
      color: var(--v-accentText-base);
      padding: 4px 16px;
      border-radius: 40px;
      z-index: 1;
    }

    .promo-content {
      //max-height: 114px;
      height: 160px;
      //height: 150px;
      position: absolute;
      //bottom: 0px;
      //top: 36px;
      top: 100px;
      overflow: auto;
      width: 100%;
      padding: 8px;
      //background-color: rgba(white, 0.9);
      .promo-title {
        font-weight: bold;
      }
      .promo-detail {
        font-size: 0.8em;

        /*         overflow: auto;
        white-space: pre-line;
        text-overflow: ellipsis;
        padding-right: 5px; */

        /*         display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;    */
      }

      .promo-title-size-small {
        font-size: 0.85em;
      }
      .promo-title-size-normal {
        font-size: 1em;
      }
      .promo-title-size-large {
        font-size: 1.5em;
      }
      .promo-title-size-xlarge {
        font-size: 2em;
      }
    }
  }
}

ul.promo-list {
  @extend .promo-list;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0px -12px;
  padding: 0px 4px;
  height: calc(#{$promo-height} + 20px);

  li {
    list-style-type: none;
    margin: 4px;
    white-space: nowrap;
  }
}

.promo-list-desktop::-webkit-scrollbar {
  height: 8px;
}

.promo-list-mobile::-webkit-scrollbar {
  height: 0px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
